import type { Fallacy } from "./types";
import { createStory } from "./types";

export const postHoc: Fallacy = {
    id: "post-hoc",
    name: "Post Hoc",
    emoji: "🔗",
    category: "Logika Rusak",
    description:
      "Menganggap sesuatu adalah penyebab karena **terjadi lebih dulu**. **Urutan waktu bukan bukti** sebab-akibat.",
    tldr: "Terjadi sebelumnya bukan berarti jadi penyebabnya. Korelasi ≠ kausalitas.",
    detail:
      "Post Hoc Ergo Propter Hoc (Latin: 'sesudah ini, maka karena ini') adalah kesalahan logika di mana seseorang menyimpulkan bahwa karena B terjadi setelah A, maka **A pasti menyebabkan B**. Padahal, dua peristiwa yang berurutan **belum tentu punya hubungan sebab-akibat** — bisa kebetulan, atau ada faktor ketiga.\n\nKenapa berbahaya? Karena bisa mengarah ke takhayul dan pseudoscience. Obat yang 'berhasil' mungkin hanya kebetulan tubuh sedang sembuh sendiri.\n\nCara mengenali: Apakah ada bukti mekanisme sebab-akibat yang jelas? Sudah diuji terkontrol? Atau cuma kebetulan waktu?",
    story: createStory("Post Hoc", "🔗", {
      hook: {
        title: "A terjadi. Terus B terjadi.",
        body: "Berarti A penyebab B? Belum tentu. Urutan waktu **bukan bukti** sebab-akibat.",
      },
      convo: {
        claim: "Sejak pake baju merah, tim aku menang terus 3 kali berturut-turut. **Baju merahnya yang bikin menang**, aku yakin banget. Gak berani ganti baju lain sekarang.",
        response: "Timnya emang lagi bagus. **Warna baju gak ngaruh ke skor.**",
      },
      reveal: {
        body: "Kamu nyimpulin A **menyebabkan** B cuma karena A **terjadi duluan**. Padahal bisa kebetulan, atau ada faktor lain.",
      },
      insight: {
        title: "Kenapa ini bahaya?",
        body: "Dari sinilah **takhayul dan pseudoscience** lahir. \"Minum ini terus sembuh\" — padahal mungkin tubuh emang lagi sembuh sendiri.",
      },
      engagement: {
        title: "Takhayul apa yang kamu masih diam-diam percaya?",
        body: "Baju keberuntungan atau ritual sebelum ujian? **Share pengalaman kamu di komen!** 👇",
      },
    }),
    related: ["circular-reasoning", "hasty-generalization", "appeal-to-nature"],
  };
